import React from "react";
import Loading from "../../components/loading/Loading";

const Help = () => {
  return (
    <div>
      <div>Help In Application</div>
    </div>
  );
};

export default Help;
